import { gql } from "graphql-request";

export const NextGenStandardFieldsFragment = gql`
  fragment NextGenStandardFieldsFragment on NextGenStandardReportSearchResult {
    standardReportId
    lensId
    name
    subdomain
  }
`;
